import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/ops/legal")({
  component: () => <Outlet />,
  head: () => ({ meta: [{ title: "Legal y Compliance — Structura Admin" }] }),
});
